<div class="zoom-out">
	<router-outlet />
</div>

<app-ui-dialog-host />
